import React, { createContext, useState, useContext } from "react";

const EnergiaEletricaCompradaContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaEletricaComprada_id, setEnergiaEletricaComprada_id] = useState();

  return (
    <EnergiaEletricaCompradaContext.Provider value={{ energiaEletricaComprada_id, setEnergiaEletricaComprada_id }} >
      {children}
    </EnergiaEletricaCompradaContext.Provider>
  );
}

export function useEnergiaEletricaCompradaContext() {
  const context = useContext(EnergiaEletricaCompradaContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaEletricaComprada_id, setEnergiaEletricaComprada_id } = context;
  return { energiaEletricaComprada_id, setEnergiaEletricaComprada_id };
}

